import { render, staticRenderFns } from "./UniversalForm.vue?vue&type=template&id=b2bd7b90&"
import script from "./UniversalForm.vue?vue&type=script&lang=ts&"
export * from "./UniversalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports